module.exports = __webpack_public_path__ + "static/trioimg2-a0848de0d48a0f8bda41532149a83806.png";